export default {"src":"/_next/static/media/ensinio_logo_dark_new.c0c3b507.svg","height":40,"width":159,"blurWidth":0,"blurHeight":0};